import { BASE_URL, INDUSTRY } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { IIndustryInput } from "models/industry";

export async function getIndustries(params: string = "") {
  const response = await axios.get(BASE_URL + INDUSTRY + params);
  return response.data;
}
export async function addIndustry(data: IIndustryInput) {
  const response = await axios.post(BASE_URL + INDUSTRY, data);
  return response.data;
}
export async function editIndustry(data: IIndustryInput, id: string) {
  const response = await axios.put(BASE_URL + INDUSTRY + '/' + id, data);
  return response.data;
}

export async function deleteIndustry(id: string) {
  const response = await axios.delete(BASE_URL + INDUSTRY + "/" + id);
  return response.data;
}

export const IndustryCells: HeadCell[] = [
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "T_name",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];
